import { HeaderModel, HeaderNavigationModel, LinkModel } from '@/types';
import HamburgerMenu from '@/assets/hamburger-menu.svg';
import MagnifyingGlassLight from '@/assets/magnifyingGlassLight.svg';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import LoginLogoutBtn from '../LoginLogoutBtn';
import UserNavigation from '../UserNavigation';
import MobileNavAppSubmenu from './MobileNavAppSubmenu';
import MobileNavAppMenu from './MobileNavAppMenu';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';

type MobileNavAppModel = {
  data: HeaderModel;
  links: HeaderNavigationModel[];
  iconLinks: { icon: React.ReactNode; link: LinkModel }[];
  className?: string;
};

const MobileNavApp = ({ data, links, iconLinks, className }: MobileNavAppModel) => {
  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState<HeaderNavigationModel | null>(null);
  const [focusSearchInput, setFocusSearchInput] = useState(false);
  const router = useRouter();

  const { data: userSession } = useSession();
  const isLoggedIn = !!userSession?.user?.email;

  useEffect(() => {
    closeSubNav();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath]);

  const closeNav = () => {
    setOpen(false);
    setFocusSearchInput(false);
  };

  const closeSubNav = () => {
    setActiveMenu(null);
    closeNav();
  };

  const openSearch = () => {
    setOpen(true);
    setFocusSearchInput(true);
  };

  return (
    <div className={className}>
      <div className="flex gap-3">
        <button
          className={classNames('align-center flex h-8 w-8 items-center justify-center rounded-full', className)}
          onClick={openSearch}
        >
          <MagnifyingGlassLight className="h-6 w-6 fill-black" />
        </button>
        <button
          className={classNames('align-center flex h-8 w-8 items-center justify-center rounded-full', className)}
          onClick={() => setOpen(true)}
        >
          <HamburgerMenu className="h-7 w-7 fill-black" />
        </button>
      </div>

      <div
        className={classNames(
          'fixed top-0 left-0 h-full w-full bg-black/40 transition-opacity duration-500',
          open ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0',
        )}
      />

      <div
        className={classNames(
          'fixed top-0 right-0 z-50 h-dvh w-full transition-transform duration-300 ease-out md:w-[425px]',
          open ? 'disable-scroll translate-x-0 shadow-2xl' : 'translate-x-full',
        )}
      >
        <div className="flex h-full flex-col bg-white">
          <div className="relative flex flex-1 flex-col overflow-hidden">
            <MobileNavAppMenu
              focusSearchInput={focusSearchInput}
              links={links}
              iconLinks={iconLinks}
              setActiveMenu={setActiveMenu}
              closeNav={closeNav}
            />
            <MobileNavAppSubmenu menu={activeMenu} closeNav={closeSubNav} closeSubNav={() => setActiveMenu(null)} />
          </div>
          <div className="bg-gray-2 container flex h-14 shrink-0 items-center justify-between">
            <UserNavigation links={data.userNavigationLinks} notificationsCount={data.notificationsCount} />
            {(data.loginLink || data.logoutLink || isLoggedIn) && (
              <LoginLogoutBtn
                loginLink={data.loginLink}
                logoutLink={data.logoutLink}
                className="!border-0 !text-base !font-bold"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavApp;
